import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Hero17 from '../components/hero17'
import Features24 from '../components/features24'
import CTA26 from '../components/cta26'
import Features25 from '../components/features25'
import Pricing14 from '../components/pricing14'
import Steps2 from '../components/steps2'
import Testimonial17 from '../components/testimonial17'
import Contact10 from '../components/contact10'
import Footer4 from '../components/footer4'

import './home.css'

const Home = () => {
  const [showNavbar, setShowNavbar] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const navbarRef = useRef(null)
  const contentRef = useRef(null)

  // Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false)
      } else {
        setShowNavbar(true)
      }

      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  // Dynamic top padding for content
  useEffect(() => {
    if (navbarRef.current && contentRef.current) {
      const navbarHeight = navbarRef.current.offsetHeight
      contentRef.current.style.paddingTop = `${220}px`
    }
  }, [])

  return (
    <div ref={contentRef} className="home-container">
      <Helmet>
        <title>E Lembos</title>
        <meta property="og:title" content="E Lembos" />
      </Helmet>

      <div
        ref={navbarRef}
        className={`navbar-wrapper ${showNavbar ? 'navbar-visible' : 'navbar-hidden'}`}
      >
        <Navbar8 />
      </div>

      {/* Sections */}
      <section id="home">
        <Hero17
          action1={<Fragment><span className="home-text114 thq-body-small">Explore Our Products</span></Fragment>}
          action2={<Fragment><span className="home-text115 thq-body-small">Meet Our Team</span></Fragment>}
          content1={<Fragment><span className="home-text116 thq-body-large">E Lembos Life Sciences is dedicated to ensuring the safety and integrity of pharmaceutical products through cutting-edge medicine marketing solutions.</span></Fragment>}
          heading1={<Fragment><span className="home-text117 thq-heading-1">Revolutionizing Pharma Marketing with Innovative Medicine Marketing Solutions</span></Fragment>}
        />
      </section>

      <section id="about">
        <Features24
          feature1Title={<Fragment><span className="home-text118 thq-heading-2">Innovative Marketing Solutions</span></Fragment>}
          feature2Title={<Fragment><span className="home-text119 thq-heading-2">Customized Options</span></Fragment>}
          feature3Title={<Fragment><span className="home-text120 thq-heading-2">Start your journey with us</span></Fragment>}
          feature1Description={<Fragment><span className="home-text121 thq-body-small">Founded in 2016 but separately established in 2022...</span></Fragment>}
          feature2Description={<Fragment><span className="home-text122 thq-body-small">At the core of our philosophy is the belief that medicine marketing is not just a functional necessity...</span></Fragment>}
          feature3Description={<Fragment><span className="home-text123 thq-body-small">Join us in our mission to redefine Pharma Marketing...</span></Fragment>}
        />
      </section>

      <section id="cta">
        <CTA26
          action1={<Fragment><span className="home-text124">Discover Our Products</span></Fragment>}
          content1={<Fragment><span className="home-text125 thq-body-large">Explore our innovative medicine marketing solutions and join us in shaping the future of pharmaceutical products.</span></Fragment>}
          heading1={<Fragment><span className="home-text126 thq-heading-2">Ready to revolutionize Pharma Marketing?</span></Fragment>}
        />
      </section>

      <section id="step">
        <Steps2
          step1Title={<Fragment><span className="home-text186 thq-heading-2">Explore our products</span></Fragment>}
          step2Title={<Fragment><span className="home-text187 thq-heading-2">Meet the team</span></Fragment>}
          step3Title={<Fragment><span className="home-text188 thq-heading-2">Share your requirements</span></Fragment>}
          step4Title={<Fragment><span className="home-text189 thq-heading-2">Take your delivery!</span></Fragment>}
          step1Description={<Fragment><span className="home-text190 thq-body-small">Explore our innovative medicine marketing solutions...</span></Fragment>}
          step2Description={<Fragment><span className="home-text191 thq-body-small">Get to know the main members...</span></Fragment>}
          step3Description={<Fragment><span className="home-text192 thq-body-small">Discover a range of services we provide...</span></Fragment>}
          step4Description={<Fragment><span className="home-text193 thq-body-small">This is the most interesting part. Receive your delivery!</span></Fragment>}
        />
      </section>

      <section id="team">
        <Testimonial17
          review1={<Fragment><span className="home-text194 thq-body-small">Dilip Kumar has 22 years of experience...</span></Fragment>}
          review2={<Fragment><span className="home-text195 thq-body-small">Think tank of E Lembos Life Sciences...</span></Fragment>}
          review3={<Fragment><span className="home-text196 thq-body-small">With a deep understanding of market trends...</span></Fragment>}
          review4={<Fragment><span className="home-text197 thq-body-small">Having 22 years Experience of Pharma Sales...</span></Fragment>}
          review5={<Fragment><span className="home-text197 thq-body-small">Having 21 years of experience in Sales...</span></Fragment>}
          content1={<Fragment><span className="home-text198 thq-body-small">Read what our clients have to say...</span></Fragment>}
          heading1={<Fragment><span className="home-text199 thq-heading-2">Meet the Team</span></Fragment>}
          author1Name={<Fragment><span className="home-text200 thq-body-large">Dilip Kumar</span></Fragment>}
          author2Name={<Fragment><span className="home-text201 thq-body-large">Prabuddha Bandyopadhyay</span></Fragment>}
          author3Name={<Fragment><span className="home-text202 thq-body-large">CA Sujeet Kumar Srivastava</span></Fragment>}
          author4Name={<Fragment><span className="home-text203 thq-body-large">Prakash Anand</span></Fragment>}
          author5Name={<Fragment><span className="home-text203 thq-body-large">Dinesh Kumar</span></Fragment>}
          author1Position={<Fragment><span className="home-text204 thq-body-small">CEO</span></Fragment>}
          author2Position={<Fragment><span className="home-text205 thq-body-small">General Manager, Marketing</span></Fragment>}
          author3Position={<Fragment><span className="home-text206 thq-body-small">Financial Advisor</span></Fragment>}
          author4Position={<Fragment><span className="home-text207 thq-body-small">Zonal Manager</span></Fragment>}
          author5Position={<Fragment><span className="home-text207 thq-body-small">Product Manager</span></Fragment>}
        />
      </section>

      <section id="contact">
        <Contact10
          content1={<Fragment><span className="home-text208 thq-body-large">Lorem ipsum dolor sit amet, consectetur adipiscing elit...</span></Fragment>}
          heading1={<Fragment><span className="home-text209 thq-heading-2">Contact us</span></Fragment>}
        />
      </section>

      <Footer4
        link1={<Fragment><span className="home-text214 thq-body-small">Home</span></Fragment>}
        link2={<Fragment><span className="home-text215 thq-body-small">About Us</span></Fragment>}
        link3={<Fragment><span className="home-text216 thq-body-small">Products</span></Fragment>}
        link4={<Fragment><span className="home-text217 thq-body-small">Team</span></Fragment>}
        link5={<Fragment><span className="home-text218 thq-body-small">Contact Us</span></Fragment>}
        termsLink={<Fragment><span className="home-text219 thq-body-small">Terms and Conditions</span></Fragment>}
        cookiesLink={<Fragment><span className="home-text220 thq-body-small">Cookies Policy</span></Fragment>}
        privacyLink={<Fragment><span className="home-text221 thq-body-small">Privacy Policy</span></Fragment>}
      />
    </div>
  )
}

export default Home
